import React from 'react';

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  color?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'medium',
  color = 'var(--tg-theme-button-color)',
}) => {
  const sizeMap = {
    small: 16,
    medium: 24,
    large: 32,
  };

  const pixelSize = sizeMap[size];

  return (
    <div
      style={{
        display: 'inline-block',
        width: pixelSize,
        height: pixelSize,
        border: `2px solid ${color}`,
        borderTopColor: 'transparent',
        borderRadius: '50%',
        animation: 'spin 0.8s linear infinite',
      }}
    >
      <style>
        {`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

interface LoadingOverlayProps {
  message?: string;
}

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ message = 'Loading...' }) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px 20px',
        gap: '16px',
      }}
    >
      <LoadingSpinner size="large" />
      <span
        style={{
          color: 'var(--tg-theme-hint-color)',
          fontSize: '14px',
        }}
      >
        {message}
      </span>
    </div>
  );
};
